import { get } from "lodash";
import { RunnerBI } from "../useGetRunnerFromBI";
import { isDuplicate } from "./utils";

const KEYPOSITION = 0;

const getExoticBets = (
  runner: RunnerBI,
  position: number,
  selections: string[][],
  isKey: boolean,
  isTrioWheel?: boolean
) => {
  const currentSelections = [...selections];

  let prev;

  if (isKey) {
    const otherPosition = Number(position === 0);
    currentSelections[otherPosition] = currentSelections[otherPosition].filter(
      (selection) => +selection !== +runner.biNumber
    );
  }

  const previousSelections: string[] = get(
    currentSelections,
    `[${position}]`,
    []
  );

  if (
    (isKey && position === KEYPOSITION) ||
    (isTrioWheel && position === KEYPOSITION)
  ) {
    prev = previousSelections.find((item: string) => +item === +runner.biNumber)
      ? previousSelections
      : [];
  } else {
    prev = [...previousSelections];
  }

  currentSelections[position || 0] = isDuplicate(prev, runner)
    ? prev.filter((item: string) => +item !== +runner.biNumber)
    : [...prev, `${runner.biNumber}`];

  return currentSelections.map((current) =>
    current === undefined ? [] : current
  );
};

export default getExoticBets;
